<template>
  <svg viewBox="0 0 100 100" width="100" height="100" class="counter__circle">
    <circle class="counter__circle-bg" cx="50" cy="50" r="40" fill="none" :style="trailStyle"></circle>
    <circle class="progress__circle-path" cx="50" cy="50" r="40" fill="none" :style="strokeStyle"></circle>
  </svg>
</template>
<script>
const name = 'Progress'

function data() {
  return {
    len: Math.PI * 2 * 40
  }
}

const props = {
  percent: {
    type: Number,
    default: 100
  },
  strokeColor: {
    type: String,
    default: '#4dcd3b'
  }
}

const computed = {
  strokeStyle: function() {
    const currPercent = this.percent * this.len;
    return {
      'stroke': this.strokeColor,
      'stroke-dasharray': `${currPercent}px, ${this.len}px`,
      'stroke-width': `4px`,
    }
  },
  trailStyle: function() {
    return {
      'stroke': '#F7F7F7',
      'stroke-dasharray': `${this.len}px, ${this.len}px`,
      'stroke-width': `4px`,
    }
  },
}
export default {
  name,
  data,
  props,
  computed
}

</script>
